import { SortType, SortDirection } from '../constants-types/Enums';

export class SortInfo {
    constructor(
        public sortType: SortType,
        public direction: SortDirection
    ) {}
}
